import { UserLoginType } from "@/DTO";
import { Api } from "@/api";

export const ChangeStatus = (user: UserLoginType, id: string) => {
  return new Promise<{}>((resolve, reject) => {
    const api = new Api({
      method: "patch",
      path: `category/change-status/${id}`,
      header: {
        Authorization: "Bearer " + user?.accessToken,
      },
    });
    return api
      .call()
      .then((data) => {
        return resolve({
          data,
        });
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
